<template>
  <div class="demand-create-wrap">
    <!-- 模式切换 -->
    <!-- <div class="mode-switch">
      <a-radio-group v-model="publishMode" button-style="solid" size="large">
        <a-radio-button value="step">十步法发布</a-radio-button>
        <a-radio-button value="normal">普通发布</a-radio-button>
      </a-radio-group>
    </div> -->

    <!-- 十步法发布模式 -->
    <div v-if="publishMode === 'step'" class="step-mode-wrap">
      <div class="step-header">
        <h2>发布技术需求</h2>
        <div class="step-progress">
          <div class="step-info">
            <span class="current-step">当前步骤 <strong>{{ currentStep + 1 }}</strong>/{{ steps.length }}</span>
            <span class="completion">填写完整度 <strong>{{ completionRate }}%</strong></span>
            <span class="tip">[Enter]可跳转到</span>
            <a-input-number v-model="jumpStep" :min="0" :max="steps.length - 1" size="small" style="width: 60px; margin: 0 5px" />
            <span class="tip">步骤（0-{{ steps.length - 1 }}）</span>
          </div>
        </div>
      </div>

      <!-- 步骤导航条 -->
      <div class="step-nav-container">
        <div class="step-nav">
          <div
            v-for="(step, index) in steps"
            :key="index"
            :class="['step-item', { active: currentStep === index, completed: index < currentStep }]"
            @mouseenter="handleStepHover(index)"
            @mouseleave="handleStepLeave"
            @click="goToStep(index)"
          >
            <div class="step-icon">
              <span>Step{{ index + 1 }}</span>
            </div>
            <div class="step-title">{{ step.title }}</div>
          </div>
        </div>
      </div>

      <!-- 步骤内容区域 -->
      <a-spin :spinning="confirmLoading">
        <div class="step-content-wrap">
          <transition name="slide-fade" mode="out-in">
            <div :key="currentStep" class="step-content">
              <j-form-container>
                <a-form-model
                  ref="stepForm"
                  :model="model"
                  :rules="validatorRules"
                  slot="detail"
                >
                  <!-- Step 0: 基本信息 -->
                  <div v-show="currentStep === 0">
                    <h3 class="step-section-title">基本信息</h3>
                    <a-row :gutter="16">
                      <a-col :span="24">
                        <a-form-model-item
                          label="需求名称"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="name"
                        >
                          <a-input
                            v-model="model.name"
                            placeholder="请填写需求名称"
                          ></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24">
                        <a-form-model-item
                          label="预算经费"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="budget"
                        >
                          <a-input-number
                            v-model="model.budget"
                            placeholder="请填写预算经费"
                            style="width: 100%"
                          >
                            <span slot="addonAfter">万元</span>
                          </a-input-number>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24">
                        <a-form-model-item
                          label="技术领域"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="technicalField"
                        >
                          <j-category-select
                            v-model="model.technicalField"
                            pcode="B03"
                            placeholder="请选择技术领域"
                          />
                          <!-- 推荐列表：相同技术领域的已审核需求（十步法模式） -->
                          <div v-if="model.technicalField" class="recommend-wrap">
                            <div class="recommend-header">
                              <span class="title">相似需求</span>
                            </div>
                            <a-spin :spinning="recommendLoading" size="small">
                              <div
                                v-if="recommendList && recommendList.length"
                                class="recommend-list"
                              >
                                <div
                                  v-for="item in recommendList"
                                  :key="item.id"
                                  class="recommend-item"
                                  @click="goDemandDetail(item)"
                                >
                                  <div class="name" :title="item.name">
                                    {{ item.name }}
                                  </div>
                                  <div class="meta">
                                    <span class="company">
                                      {{ item.companyName || '未填写' }}
                                    </span>
                                    <span class="dot">·</span>
                                    <span class="area">
                                      {{ getAreaText(item.areaI) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <a-empty v-else class="recommend-empty">
                                <span slot="description">暂无推荐需求</span>
                              </a-empty>
                            </a-spin>
                          </div>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24" v-if="model.technicalField=='2000847103995158530'" >
                        <a-form-model-item
                          label="其他技术领域"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="technicalFieldCustom"
                        >
                          <a-input v-model="model.technicalFieldCustom" placeholder="请填写其他技术领域"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24">
                        <a-form-model-item
                          label="行业分类"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="industryField"
                        >
                          <j-category-select
                            v-model="model.industryField"
                            pcode="B04"
                            placeholder="请选择行业分类"
                          />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>

                  <!-- Step 1: 需求主体 -->
                  <div v-show="currentStep === 1">
                    <h3 class="step-section-title">需求主体</h3>
                    <a-row :gutter="16">
                      <a-col :span="24">
                        <a-form-model-item
                          label="公司名称"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="companyName"
                        >
                          <a-input
                            v-model="model.companyName"
                            placeholder="请填写公司名称"
                          ></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24">
                        <a-form-model-item
                          label="需求类别"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="requirementType"
                        >
                          <j-dict-select-tag
                            type="radio"
                            v-model="model.requirementType"
                            dictCode="requirement_type"
                            placeholder="请选择需求类别"
                          />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>

                  <!-- Step 2: 联系方式 -->
                  <div v-show="currentStep === 2">
                    <h3 class="step-section-title">联系方式</h3>
                    <a-row :gutter="16">
                      <a-col :span="24">
                        <a-form-model-item
                          label="联系人"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="contactName"
                        >
                          <a-input
                            v-model="model.contactName"
                            placeholder="请填写联系人"
                          ></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24">
                        <a-form-model-item
                          label="联系电话"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="contactPhone"
                        >
                          <a-input
                            v-model="model.contactPhone"
                            placeholder="请填写联系电话"
                          ></a-input>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>

                  <!-- Step 3: 需求地点 -->
                  <div v-show="currentStep === 3">
                    <h3 class="step-section-title">需求地点</h3>
                    <a-row :gutter="16">
                      <a-col :span="24">
                        <a-form-model-item
                          label="需求地点"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="areaId"
                        >
                          <j-area-linkage
                            type="cascader"
                            v-model="model.areaId"
                            placeholder="请选择"
                          />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>

                  <!-- Step 4: 公开设置 -->
                  <div v-show="currentStep === 4">
                    <h3 class="step-section-title">公开设置</h3>
                    <a-row :gutter="16">
                      <a-col :span="24">
                        <a-form-model-item
                          label="是否公开"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="isOpen"
                        >
                          <j-dict-select-tag
                            type="radio"
                            v-model="model.isOpen"
                            dictCode="isOpen"
                            placeholder="请选择"
                          />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>

                  <!-- Step 5: 紧急程度 -->
                  <div v-show="currentStep === 5">
                    <h3 class="step-section-title">紧急程度</h3>
                    <a-row :gutter="16">
                      <a-col :span="24">
                        <a-form-model-item
                          label="紧急程度"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="urgentLevel"
                        >
                          <j-dict-select-tag
                            type="radio"
                            v-model="model.urgentLevel"
                            dictCode="urgent_level"
                            placeholder="请选择紧急程度"
                          />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>

                  <!-- Step 6: 详细信息 -->
                  <div v-show="currentStep === 6">
                    <h3 class="step-section-title">详细信息</h3>
                    <a-row :gutter="16">
                      <a-col :span="24">
                        <a-form-model-item
                          label="关键问题"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="keyQuestion"
                        >
                          <a-textarea
                            v-model="model.keyQuestion"
                            placeholder="待解决的关键问题或关键指标定量描述"
                            :rows="4"
                          ></a-textarea>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24">
                        <a-form-model-item
                          label="技术水平"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="techLevel"
                        >
                          <a-textarea
                            v-model="model.techLevel"
                            placeholder="自身现有的技术水平及行业一流技术水平"
                            :rows="4"
                          ></a-textarea>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24">
                        <a-form-model-item
                          label="制约因素"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="restrictFactor"
                        >
                          <a-textarea
                            v-model="model.restrictFactor"
                            placeholder="主要制约因素"
                            :rows="4"
                          ></a-textarea>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>

                  <!-- Step 7: 投入与收益 -->
                  <div v-show="currentStep === 7">
                    <h3 class="step-section-title">投入与收益</h3>
                    <a-row :gutter="16">
                      <a-col :span="24">
                        <a-form-model-item
                          label="预期收益"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="predictProfit"
                        >
                          <j-dict-select-tag
                            type="list"
                            v-model="model.predictProfit"
                            dictCode="predict_profit"
                            placeholder="需求得到满足后预期可产生的收益"
                          />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24">
                        <a-form-model-item
                          label="投入金额"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="investMoney"
                        >
                          <j-dict-select-tag
                            type="list"
                            v-model="model.investMoney"
                            dictCode="invest_money"
                            placeholder="愿意投入的金额"
                          />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24">
                        <a-form-model-item
                          label="投入资源"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="resourceDescription"
                        >
                          <a-textarea
                            v-model="model.resourceDescription"
                            placeholder="愿意投入的资源"
                            :rows="4"
                          ></a-textarea>
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24">
                        <a-form-model-item
                          label="解决方式"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="solveType"
                        >
                          <j-multi-select-tag
                            type="list_multi"
                            v-model="model.solveType"
                            dictCode="solve_type"
                            placeholder="需求解决方式"
                          />
                        </a-form-model-item>
                      </a-col>
                      <a-col :span="24">
                        <a-form-model-item
                          label="关联服务"
                          :labelCol="labelCol"
                          :wrapperCol="wrapperCol"
                          prop="refRequirement"
                        >
                          <j-multi-select-tag
                            type="list_multi"
                            v-model="model.refRequirement"
                            dictCode="ref_requirement"
                            placeholder="还需要哪些关联服务需求"
                          />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </div>
                </a-form-model>
              </j-form-container>
            </div>
          </transition>

          <!-- 步骤导航按钮 -->
          <div class="step-actions">
            <a-button v-if="currentStep > 0" size="large" @click="prevStep">上一步</a-button>
            <a-button v-if="currentStep < steps.length - 1" size="large" type="primary" @click="nextStep">下一步</a-button>
            <a-button v-if="currentStep === steps.length - 1" size="large" type="primary" @click="submitForm">提交</a-button>
            <span class="completion-tip" v-if="completionRate < 50">
              完整度大于50%方可提交
            </span>
          </div>
        </div>
      </a-spin>
    </div>

    <!-- 普通发布模式 -->
    <div v-if="publishMode === 'normal'" class="normal-mode-wrap">
      <div>
        <a-row>
          <a-col :span="12">
            <h2>发布技术需求</h2>
          </a-col>
          <a-col :span="12">
            <a-steps>
              <a-step status="process" title="填写资料">
                <a-icon slot="icon" type="user" />
              </a-step>
              <a-step status="wait" title="人工审核">
                <a-icon slot="icon" type="solution" />
              </a-step>
              <a-step status="finish" title="审核成功">
                <a-icon slot="icon" type="smile-o" />
              </a-step>
            </a-steps>
          </a-col>
        </a-row>
      </div>
      <a-divider></a-divider>
      <a-spin :spinning="confirmLoading">
        <j-form-container>
          <a-form-model
            ref="normalForm"
            :model="model"
            :rules="validatorRules"
            slot="detail"
          >
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  label="需求名称"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="name"
                >
                  <a-input
                    v-model="model.name"
                    placeholder="请输入需求名称"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="预算经费"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="budget"
                >
                  <a-input-number
                    v-model="model.budget"
                    placeholder="请输入预算经费"
                    style="width: 100%"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="技术领域"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="technicalField"
                >
                  <j-category-select
                    v-model="model.technicalField"
                    pcode="B03"
                    placeholder="请选择技术领域"
                  />
                  <!-- 推荐列表：相同技术领域的已审核需求（普通模式） -->
                  <div v-if="model.technicalField" class="recommend-wrap">
                    <div class="recommend-header">
                      <span class="title">相同技术领域的需求推荐</span>
                      <span class="sub">基于已审核需求智能推荐</span>
                    </div>
                    <a-spin :spinning="recommendLoading" size="small">
                      <div
                        v-if="recommendList && recommendList.length"
                        class="recommend-list"
                      >
                        <div
                          v-for="item in recommendList"
                          :key="item.id"
                          class="recommend-item"
                          @click="goDemandDetail(item)"
                        >
                          <div class="name" :title="item.name">
                            {{ item.name }}
                          </div>
                          <div class="meta">
                            <span class="company">
                              {{ item.companyName || '未填写' }}
                            </span>
                            <span class="dot">·</span>
                            <span class="area">
                              {{ item.areaId_dictText || item.areaText || '未填写' }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <a-empty v-else class="recommend-empty">
                        <span slot="description">暂无推荐需求</span>
                      </a-empty>
                    </a-spin>
                  </div>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="行业分类"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="industryField"
                >
                  <j-category-select
                    v-model="model.industryField"
                    pcode="B04"
                    placeholder="请选择行业分类"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="公司名称"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="companyName"
                >
                  <a-input
                    v-model="model.companyName"
                    placeholder="请输入公司名称"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="需求类别"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="requirementType"
                >
                  <j-dict-select-tag
                    type="list"
                    v-model="model.requirementType"
                    dictCode="requirement_type"
                    placeholder="请选择需求类别"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="联系人"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="contactName"
                >
                  <a-input
                    v-model="model.contactName"
                    placeholder="请输入联系人"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="联系电话"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="contactPhone"
                >
                  <a-input
                    v-model="model.contactPhone"
                    placeholder="请输入联系电话"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="需求地点"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="areaId"
                >
                  <j-area-linkage
                    type="cascader"
                    v-model="model.areaId"
                    placeholder="请输入省市区"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="是否公开"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="isOpen"
                >
                  <j-dict-select-tag
                    type="radio"
                    v-model="model.isOpen"
                    dictCode="isOpen"
                    placeholder="请选择是否公开"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="紧急程度"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="urgentLevel"
                >
                  <j-dict-select-tag
                    type="list"
                    v-model="model.urgentLevel"
                    dictCode="urgent_level"
                    placeholder="请选择紧急程度"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="关键问题"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="keyQuestion"
                >
                  <a-textarea
                    v-model="model.keyQuestion"
                    placeholder="待解决的关键问题或关键指标定量描述"
                    :rows="4"
                  ></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="自定义标签"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="tag"
                >
                  <a-select
                    v-model="model.tag"
                    placeholder="填写关键词，多个关键词用英文逗号分隔"
                    mode="tags"
                    style="width: 100%"
                    :token-separators="[',']"
                  >
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="技术水平"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="techLevel"
                >
                  <a-textarea
                    v-model="model.techLevel"
                    placeholder="自身现有的技术水平及行业一流技术水平"
                    :rows="4"
                  ></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="制约因素"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="restrictFactor"
                >
                  <a-textarea
                    v-model="model.restrictFactor"
                    placeholder="主要制约因素"
                    :rows="4"
                  ></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="努力与成本"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="tryEffort"
                >
                  <a-textarea
                    v-model="model.tryEffort"
                    placeholder="已经做出的努力和尝试及付出的成本"
                    :rows="4"
                  ></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="方案约束"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="planConstraint"
                >
                  <a-textarea
                    v-model="model.planConstraint"
                    placeholder="对解决方案的条件约束"
                    :rows="4"
                  ></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="预期收益"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="predictProfit"
                >
                  <j-dict-select-tag
                    type="list"
                    v-model="model.predictProfit"
                    dictCode="predict_profit"
                    placeholder="需求得到满足后预期可产生的收益"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="经历要求"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="expRequire"
                >
                  <a-textarea
                    v-model="model.expRequire"
                    placeholder="对需求解答人或团队的从业经历和项目经历要求"
                    :rows="4"
                  ></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="投入金额"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="investMoney"
                >
                  <j-dict-select-tag
                    type="list"
                    v-model="model.investMoney"
                    dictCode="invest_money"
                    placeholder="愿意投入的金额"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="投入资源"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="resourceDescription"
                >
                  <a-textarea
                    v-model="model.resourceDescription"
                    placeholder="愿意投入的资源"
                    :rows="4"
                  ></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="解决方式"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="solveType"
                >
                  <j-multi-select-tag
                    type="list_multi"
                    v-model="model.solveType"
                    dictCode="solve_type"
                    placeholder="需求解决方式"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item
                  label="关联服务"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  prop="refRequirement"
                >
                  <j-multi-select-tag
                    type="list_multi"
                    v-model="model.refRequirement"
                    dictCode="ref_requirement"
                    placeholder="还需要哪些关联服务需求"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </j-form-container>
      </a-spin>

      <div class="btn-wrap">
        <a-button size="large" type="default" @click="cancel">取消</a-button>
        <a-button size="large" type="primary" @click="submitForm">提交</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { httpAction, getAction } from "@/api/manage";
import JAreaLinkage from "@comp/jeecg/JAreaLinkage";
import JCategorySelect from "@comp/jeecg/JCategorySelect";
import JMultiSelectTag from '@/components/dict/JMultiSelectTag'

export default {
  name: "DemandCreate",
  components: {
    JAreaLinkage,
    JCategorySelect,
    JMultiSelectTag,
  },
  data() {
    return {
      publishMode: "step", // 发布模式：step-十步法，normal-普通
      currentStep: 0,
      jumpStep: 0,
      hoveredStep: null,
      recommendLoading: false,
      recommendList: [],
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      steps: [
        { title: "基本信息", fields: ["name", "budget", "technicalField", "industryField"] },
        { title: "需求主体", fields: ["companyName", "requirementType"] },
        { title: "联系方式", fields: ["contactName", "contactPhone"] },
        { title: "需求地点", fields: ["areaId"] },
        { title: "公开设置", fields: ["isOpen"] },
        { title: "紧急程度", fields: ["urgentLevel"] },
        { title: "详细信息", fields: ["keyQuestion", "techLevel", "restrictFactor"] },
        { title: "投入收益", fields: ["predictProfit", "investMoney", "resourceDescription", "solveType", "refRequirement"] },
      ],
      validatorRules: {
        name: [{ required: true, message: "请输入需求名称!" }],
        budget: [
          { required: true, message: "请输入预算经费!" },
          {
            pattern: /^(([1-9][0-9]*)|([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2}))$/,
            message: "请输入正确的金额!",
          },
        ],
        technicalField: [{ required: true, message: "请输入技术领域!" }],
        technicalFieldCustom: [{ required: true, message: "请输入技术领域!" }],
        industryField: [{ required: true, message: "请输入行业分类!" }],
        companyName: [{ required: true, message: "请输入公司名称!" }],
        requirementType: [{ required: true, message: "请输入需求类别!" }],
        contactName: [{ required: true, message: "请输入联系人!" }],
        contactPhone: [
          { required: true, message: "请输入联系电话!" },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号码!" },
        ],
        areaId: [{ required: true, message: "请输入需求地点!" }],
        isOpen: [{ required: true, message: "请选择是否公开!" }],
        urgentLevel: [{ required: true, message: "请输入紧急程度!" }],
        predictProfit: [{ required: true, message: "请选择预期收益!" }],
        investMoney: [{ required: true, message: "请选择投入金额!" }],
      },
      url: {
        add: "/xjtech/techRequirement/add",
        edit: "/xjtech/techRequirement/edit",
        queryById: "/xjtech/techRequirement/queryById",
      },
    };
  },
  computed: {
    completionRate() {
      const requiredFields = [
        "name",
        "budget",
        "technicalField",
        "industryField",
        "companyName",
        "requirementType",
        "contactName",
        "contactPhone",
        "areaId",
        "isOpen",
        "urgentLevel",
        "predictProfit",
        "investMoney",
      ];
      let filledCount = 0;
      requiredFields.forEach((field) => {
        if (this.model[field]) {
          filledCount++;
        }
      });
      return Math.floor((filledCount / requiredFields.length) * 100);
    },
  },
  watch: {
    "$route.query.id"(val) {
      if (val) {
        this.loadRecord(val);
      } else {
        this.resetForm();
      }
    },
    "model.technicalField"(val) {
      if (val) {
        this.loadRecommendList();
      } else {
        this.recommendList = [];
      }
    },
  },
  created() {
    this.modelDefault = JSON.parse(JSON.stringify(this.model));
    const id = this.$route.query.id;
    if (id) {
      this.loadRecord(id);
    }
  },
  mounted() {
    // 监听键盘事件
    document.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    handleKeydown(e) {
      if (
        e.key === "Enter" &&
        this.publishMode === "step" &&
        this.jumpStep >= 0 &&
        this.jumpStep <= this.steps.length - 1
      ) {
        this.goToStep(this.jumpStep);
      }
    },
    handleStepHover(index) {
      this.hoveredStep = index;
    },
    handleStepLeave() {
      this.hoveredStep = null;
    },
    goToStep(index) {
      if (index >= 0 && index < this.steps.length) {
        this.currentStep = index;
      }
    },
    nextStep() {
      if (this.currentStep < this.steps.length - 1) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    cancel() {
      this.resetForm();
    },
    submitForm() {
      const that = this;
      const form = this.publishMode === "step" ? this.$refs.stepForm : this.$refs.normalForm;

      // 检查完整度（仅在十步法模式下）
      if (this.publishMode === "step" && this.completionRate < 50) {
        that.$message.warning("完整度大于50%方可提交");
        return;
      }

      // 触发表单验证
      form.validate((valid, errors) => {
        if (!valid && errors) {
          const firstErrorKey = Object.keys(errors)[0];
          const firstErrorList = firstErrorKey ? errors[firstErrorKey] : [];
          const firstError = Array.isArray(firstErrorList)
            ? firstErrorList[0]
            : null;
          const errorMessage =
            (firstError && firstError.message) || "表单校验未通过，请检查输入";
          that.$message.warning(errorMessage);
          return;
        }
        if (valid) {
          that.confirmLoading = true;
          const payload = { ...this.model };
          if (Array.isArray(payload.tag)) {
            payload.tag = payload.tag.join(",");
          }
          if (Array.isArray(payload.solveType)) {
            payload.solveType = payload.solveType.join(",");
          }
          if (Array.isArray(payload.refRequirement)) {
            payload.refRequirement = payload.refRequirement.join(",");
          }
          const isEdit = !!this.model.id;
          const url = isEdit ? this.url.edit : this.url.add;
          const method = isEdit ? "put" : "post";
          httpAction(url, payload, method)
            .then((res) => {
              if (res.success) {
                that.$message.success("提交成功");
                if (isEdit) {
                  this.$router.push({ path: "/personal" });
                } else {
                  form.resetFields();
                  that.model = JSON.parse(JSON.stringify(that.modelDefault));
                  if (that.publishMode === "step") {
                    that.currentStep = 0;
                  }
                }
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
    loadRecord(id) {
      this.confirmLoading = true;
      getAction(this.url.queryById, { id })
        .then((res) => {
          if (res.success) {
            const result = res.result || {};
            result.tag = this.normalizeToArray(result.tag);
            result.solveType = this.normalizeToArray(result.solveType);
            result.refRequirement = this.normalizeToArray(result.refRequirement);
            this.model = result;
          } else {
            this.$message.warning(res.message || "加载数据失败");
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    normalizeToArray(value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (typeof value === "string" && value.length) {
        return value.split(",").filter((item) => item !== "");
      }
      return [];
    },
    resetForm() {
      const form = this.publishMode === "step" ? this.$refs.stepForm : this.$refs.normalForm;
      if (form) {
        form.resetFields();
      }
      this.model = JSON.parse(JSON.stringify(this.modelDefault));
      this.currentStep = 0;
    },
    // 加载推荐列表：相同技术领域的已审核需求
    loadRecommendList() {
      if (!this.model || !this.model.technicalField) {
        this.recommendList = [];
        return;
      }
      this.recommendLoading = true;
      const params = {
        technicalField: this.model.technicalField,
        reviewStatus: 1,
        pageNo: 1,
        pageSize: 5,
        column: "createTime",
        order: "desc",
      };
      getAction("/xjtech/techRequirement/list", params)
        .then((res) => {
          if (res && res.success) {
            const result = res.result || [];
            const records = Array.isArray(result) ? result : result.records || [];
            this.recommendList = records || [];
          } else {
            this.recommendList = [];
          }
        })
        .catch(() => {
          this.recommendList = [];
        })
        .finally(() => {
          this.recommendLoading = false;
        });
    },
    getAreaText(code) {
      if (!code || !this.pcaData) {
        return ''
      }
      return this.pcaData.getText(code)
    },
    // 跳转到需求详情
    goDemandDetail(record) {
      if (!record || !record.id) return;
      const result = this.$router.resolve({
        path: "/demand/detail",
        query: { id: record.id },
      });
      window.open(result.href, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
.demand-create-wrap {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  .mode-switch {
    text-align: center;
    margin-bottom: 30px;
  }

  // 十步法模式样式
  .step-mode-wrap {
    .step-header {
      margin-bottom: 20px;

      h2 {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 15px;
      }

      .step-progress {
        background: #f5f5f5;
        padding: 15px 20px;
        border-radius: 4px;

        .step-info {
          display: flex;
          align-items: center;
          gap: 20px;

          .current-step,
          .completion {
            font-size: 14px;
            color: #666;

            strong {
              color: #1890ff;
              font-size: 18px;
              margin: 0 5px;
            }
          }

          .tip {
            font-size: 12px;
            color: #999;
          }
        }
      }
    }

    .step-nav-container {
      margin-bottom: 30px;
      overflow-x: auto;
      overflow-y: hidden;

      .step-nav {
        display: flex;
        min-width: 1000px;
        border-bottom: 2px solid #e8e8e8;

        .step-item {
          flex: 1;
          text-align: center;
          padding: 15px 10px;
          cursor: pointer;
          position: relative;
          transition: all 0.3s ease;
          border-bottom: 3px solid transparent;

          &:hover {
            background: #f0f7ff;
            transform: translateY(-2px);
          }

          &.active {
            border-bottom-color: #1890ff;

            .step-icon {
              background: #1890ff;
              color: white;
            }

            .step-title {
              color: #1890ff;
              font-weight: 600;
            }
          }

          &.completed {
            .step-icon {
              background: #52c41a;
              color: white;
            }
          }

          .step-icon {
            display: inline-block;
            width: 80px;
            height: 40px;
            line-height: 40px;
            background: #f0f0f0;
            border-radius: 4px;
            margin-bottom: 8px;
            font-size: 14px;
            transition: all 0.3s ease;
          }

          .step-title {
            font-size: 12px;
            color: #666;
            transition: all 0.3s ease;
          }
        }
      }
    }

    .step-content-wrap {
      min-height: 400px;
      background: #fff;
      padding: 30px;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

      .step-content {
        .step-section-title {
          font-size: 18px;
          font-weight: 600;
          color: #333;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 2px solid #1890ff;
        }
      }

      .step-actions {
        margin-top: 30px;
        padding-top: 20px;
        border-top: 1px solid #e8e8e8;
        text-align: center;

        .ant-btn {
          min-width: 120px;
          margin: 0 10px;
        }

        .completion-tip {
          display: inline-block;
          margin-left: 20px;
          color: #ff4d4f;
          font-size: 14px;
        }
      }
    }
  }

  // 普通模式样式
  .normal-mode-wrap {
    max-width: 900px;
    margin: auto;

    .btn-wrap {
      text-align: center;
      margin-top: 30px;

      .ant-btn {
        width: 100px;
        margin: 8px;
      }
    }
  }

  // 推荐列表样式
  .recommend-wrap {
    margin-top: 8px;
    padding: 10px 12px;
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 4px;

    .recommend-header {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      margin-bottom: 8px;

      .title {
        font-size: 13px;
        font-weight: 600;
        color: #333;
      }
    }

    .recommend-list {
      max-height: 220px;
      overflow-y: auto;

      .recommend-item {
        padding: 6px 4px;
        cursor: pointer;
        border-radius: 3px;
        transition: all 0.2s ease;

        &:hover {
          background: #e6f7ff;
        }

        .name {
          font-size: 13px;
          color: #1890ff;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .meta {
          margin-top: 2px;
          font-size: 12px;
          color: #999;

          .dot {
            margin: 0 4px;
          }
        }
      }
    }

    .recommend-empty {
      margin: 4px 0 0;
    }
  }
}

// 过渡动画
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter {
  transform: translateX(30px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-30px);
  opacity: 0;
}
</style>
